import React from 'react';

const BRAND_ICON_OPACITY = 0.8;

/** DigitalOcean logo - simple "DO" droplet icon */
export function DigitalOceanLogo({ size = 92 }) {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="DigitalOcean"
      style={{ display: 'block', opacity: BRAND_ICON_OPACITY }}
    >
      <defs>
        <linearGradient id="doBg" x1="0" y1="0" x2="96" y2="96" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0080FF" />
          <stop offset="1" stopColor="#0069D9" />
        </linearGradient>
      </defs>
      <path
        d="M48 8C25.9 8 8 25.9 8 48s17.9 40 40 40v-13.7c-14.5 0-26.3-11.8-26.3-26.3S33.5 21.7 48 21.7 74.3 33.5 74.3 48 62.5 74.3 48 74.3V60.6c-7 0-12.6-5.6-12.6-12.6S41 35.4 48 35.4s12.6 5.6 12.6 12.6S55 60.6 48 60.6V48H35.4v12.6c-7-.0-12.6 5.6-12.6 12.6s5.6 12.6 12.6 12.6 12.6-5.6 12.6-12.6V60.6z"
        fill="url(#doBg)"
      />
    </svg>
  );
}

/** Vast.ai logo - V mark */
export function VastAiLogo({ size = 92 }) {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Vast.ai"
      style={{ display: 'block', opacity: BRAND_ICON_OPACITY }}
    >
      <defs>
        <linearGradient id="vastBg" x1="6" y1="6" x2="90" y2="90" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#243248" />
          <stop offset="1" stopColor="#1A2538" />
        </linearGradient>
        <linearGradient id="vastAccent" x1="20" y1="20" x2="76" y2="76" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#7DD3FC" />
          <stop offset="1" stopColor="#38BDF8" />
        </linearGradient>
      </defs>
      <rect x="6" y="6" width="84" height="84" rx="22" fill="url(#vastBg)" />
      <path
        d="M28 28 L48 70 L68 28"
        stroke="url(#vastAccent)"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

/** Voltage Park logo - lightning bolt */
export function VoltageParkLogo({ size = 92 }) {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Voltage Park"
      style={{ display: 'block', opacity: BRAND_ICON_OPACITY }}
    >
      <defs>
        <linearGradient id="vpBg" x1="6" y1="6" x2="90" y2="90" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#1F2937" />
          <stop offset="1" stopColor="#0F172A" />
        </linearGradient>
        <linearGradient id="vpBolt" x1="36" y1="14" x2="60" y2="80" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#FCD34D" />
          <stop offset="1" stopColor="#F59E0B" />
        </linearGradient>
      </defs>
      <rect x="6" y="6" width="84" height="84" rx="22" fill="url(#vpBg)" />
      <path
        d="M52 14 L28 52 L44 52 L40 82 L66 42 L50 42 L52 14 Z"
        fill="url(#vpBolt)"
        stroke="rgba(0,0,0,0.15)"
        strokeWidth="1"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Lambda (Lambda Cloud) logo - lambda glyph on a tile */
export function LambdaCloudLogo({ size = 92 }) {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Lambda"
      style={{ display: 'block', opacity: BRAND_ICON_OPACITY }}
    >
      <defs>
        <linearGradient id="lambdaBg" x1="6" y1="6" x2="90" y2="90" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#1F2937" />
          <stop offset="1" stopColor="#0F172A" />
        </linearGradient>
      </defs>
      <rect x="6" y="6" width="84" height="84" rx="22" fill="url(#lambdaBg)" />
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        fontSize="52"
        fontWeight="700"
        fontFamily="ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
        fill="#A78BFA"
      >
        λ
      </text>
    </svg>
  );
}

export function RunPodLogo({ size = 92 }) {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="RunPod"
      style={{ display: 'block', opacity: BRAND_ICON_OPACITY }}
    >
      <defs>
        <linearGradient id="runpodBg" x1="6" y1="6" x2="90" y2="90" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#2A1B4A" />
          <stop offset="1" stopColor="#0F0A1F" />
        </linearGradient>
      </defs>
      <rect x="6" y="6" width="84" height="84" rx="22" fill="url(#runpodBg)" />
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        fontSize="34"
        fontWeight="700"
        fontFamily="ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
        fill="#7C5CFF"
      >
        RP
      </text>
    </svg>
  );
}

/** Hugging Face logo - the iconic yellow face */
export function HuggingFaceLogo({ size = 92 }) {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Hugging Face"
      style={{ display: 'block', opacity: BRAND_ICON_OPACITY }}
    >
      <defs>
        <linearGradient id="hfFace" x1="14" y1="20" x2="80" y2="84" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#FCD34D" />
          <stop offset="1" stopColor="#F59E0B" />
        </linearGradient>
      </defs>
      <circle cx="48" cy="50" r="34" fill="url(#hfFace)" />
      <circle cx="36" cy="44" r="4.5" fill="#1F2937" />
      <circle cx="60" cy="44" r="4.5" fill="#1F2937" />
      <path
        d="M34 60 Q48 74 62 60"
        stroke="#1F2937"
        strokeWidth="3.5"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="24" cy="58" r="5.5" fill="#F87171" opacity="0.85" />
      <circle cx="72" cy="58" r="5.5" fill="#F87171" opacity="0.85" />
    </svg>
  );
}

/** vLLM logo - "vLLM" textmark on a tile */
export function VllmLogo({ size = 92 }) {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="vLLM"
      style={{ display: 'block', opacity: BRAND_ICON_OPACITY }}
    >
      <defs>
        <linearGradient id="vllmBg" x1="6" y1="6" x2="90" y2="90" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0EA5E9" />
          <stop offset="1" stopColor="#1D4ED8" />
        </linearGradient>
      </defs>
      <rect x="6" y="6" width="84" height="84" rx="22" fill="url(#vllmBg)" />
      <text
        x="50%"
        y="58%"
        textAnchor="middle"
        fontSize="26"
        fontWeight="900"
        fontFamily="ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
        fill="#F8FAFC"
        letterSpacing="-1"
      >
        vLLM
      </text>
    </svg>
  );
}

/** PyTorch logo - flame */
export function PyTorchLogo({ size = 92 }) {
  const s = size;
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="PyTorch"
      style={{ display: 'block', opacity: BRAND_ICON_OPACITY }}
    >
      <path
        d="M97.5 40.6c14.7 14.7 14.7 38.6 0 53.4-14.7 14.7-38.6 14.7-53.4 0-14.7-14.7-14.7-38.6 0-53.4l26.7-26.7v18l-1.7 1.7-15.7 15.7c-9.6 9.6-9.6 25.2 0 34.8 9.6 9.6 25.2 9.6 34.8 0 9.6-9.6 9.6-25.2 0-34.8L97.5 40.6z"
        fill="#EE4C2C"
      />
      <circle cx="84.5" cy="36.4" r="4.5" fill="#EE4C2C" />
    </svg>
  );
}
